<template>
  <div>
    <div class="footer">
      <div class="container">
        <div class="col-md-2"><img src="../images/bottom_logo.png" alt="" class="bottom_logo"></div>
        <div class="col-md-8 padding0">
          <div class="nav_bottom nav_z">
            <dl>
              <dt>{{$t('global.News')}}</dt>
              <dd>
                <router-link to="news">{{$t('global.RecentActivities')}}</router-link>
              </dd>
              <dd>
                <router-link to="newsCompany">{{$t('global.CompanyNews')}}</router-link>
              </dd>
            </dl>
            <dl>
              <dt>{{$t('global.TrackingC')}}</dt>
              <dd><router-link to="tracking">{{$t('global.STracking')}}</router-link></dd>
              <dd><router-link to="trackingPickup">{{$t('global.PCoverage')}}</router-link></dd>
              <dd><router-link to="trackingProducts">{{$t('global.PPricing')}}</router-link></dd>
              <dd><router-link to="trackingPackage">{{$t('global.PSpecifications')}}</router-link></dd>
              <dd><router-link to="trackingContrabands">{{$t('global.Contrabands')}}</router-link></dd>
            </dl>
            <dl>
              <dt><router-link to="product-list">{{$t('global.Products')}}</router-link></dt>
            </dl>
            <dl>
              <dt>{{$t('global.Help')}}</dt>
              <dd><router-link to="help">{{$t('global.BInquiries')}}</router-link></dd>
              <dd><router-link to="helpUser">{{$t('global.UserManua')}}</router-link></dd>
              <dd><router-link to="helpFAQ">{{$t('global.FAQ')}}</router-link></dd>
            </dl>
            <dl>
              <dt>{{$t('global.About')}}</dt>
              <dd><router-link to="about">{{$t('global.CInformation')}}</router-link></dd>
              <dd><router-link to="aboutRecruitment">{{$t('global.COpportunities')}}</router-link></dd>
              <dd><router-link to="aboutContact">{{$t('global.ContactUs')}}</router-link></dd>
              <dd><router-link to="aboutIntegrity">{{ $t('clause.compliance') }}</router-link></dd>
            </dl>
            <div class="clearfix"></div>
          </div>
          <!--     1     -->
          <div class="col-lg-4 padding0">
            <div class="clause_w">
              <h4 style="color: #fff;margin-bottom: 10px">{{$t('global.SpeedPAK')}}</h4>
              <router-link to="clauseConditions">{{$t('global.TermsConditions')}}</router-link>
              <router-link to="clauseService">{{$t('global.ServiceDisclaimer')}}</router-link>
              <router-link to="clausePrivacy">{{$t('global.PrivacyDisclaimer')}}</router-link>
<!--              <router-link to="clauseCompliance">{{ $t('clause.compliance') }}</router-link>-->
            </div>
            <div class="nav_info_w">
            <!--<span>{{$t('global.Address')}}</span>-->
            <table>
              <tr style="vertical-align: top">
                <td rowspan="2" class="width30">
                  {{$t('global.Tel')}}
                </td>
                <td>
                  {{$t('global.TelCN')}}
                </td>
              </tr>
              <tr>
                <td>
                  &nbsp;{{$t('global.TelHK')}}
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding:3px 0">{{ $t('global.workTime') }}</td>
              </tr>
            </table>
            <span>
              <a style="color: #fff;text-decoration: none" href="mailto:CS@orangeconnex.com?title=title1&body=body<br>new row">{{$t('global.Mail')}}</a>
            </span>
          </div>
          </div>
          <!--1-->
          <!--    2      -->
          <div class="col-lg-4 padding0">
            <div class="clause_w">
              <h4 style="color: #fff;margin-bottom: 10px">{{$t('global.consolFre')}}</h4>
              <router-link to="cfClauseConditions">{{$t('global.TermsConditions')}}</router-link>
              <router-link to="cfClauseService">{{$t('global.ServiceDisclaimer')}}</router-link>
              <router-link to="cfClausePrivacy">{{$t('global.PrivacyDisclaimer')}}</router-link>
            </div>
            <div class="nav_info_w">
              <!--<span>{{$t('global.Address')}}</span>-->
              <table>
                <tr style="vertical-align: top">
                  <td rowspan="2" class="width30" style="min-width:27px">
                    {{$t('global.Tel')}}
                  </td>
                  <td>
                    {{$t('global.cfTelCN')}}
                  </td>
                </tr>
                <br>
              </table>
              <span>
              <a style="color: #fff;text-decoration: none" href="mailto:Speedfreight@orangeconnex.com?title=title1&body=body<br>new row">{{$t('global.cfMail')}}</a>
            </span>
            </div>
          </div>
          <!--mc-->
           <div class="col-lg-4 padding0">
            <div class="clause_w">
              <h4 style="color: #fff;margin-bottom: 10px">{{ $t('product.multiChannel.title') }}</h4>
              <router-link to="mcClauseConditions">{{$t('global.TermsConditions')}}</router-link>
              <router-link to="mcClauseService">{{$t('global.ServiceDisclaimer')}}</router-link>
              <router-link to="mcClausePrivacy">{{$t('global.PrivacyDisclaimer')}}</router-link>
            </div>
            <div class="nav_info_w">
              <!--<span>{{$t('global.Address')}}</span>-->
              <table>
                <tr style="vertical-align: top">
                  <td rowspan="1" class="width30">
                    {{$t('global.Tel')}}
                </td>
                  <td>
                    {{$t('global.TelCN')}}
                  </td>
                </tr>
                <tr>
                <td colspan="2" style="padding:3px 0">{{ $t('global.workTime') }}</td>
              </tr>
              </table>
              <span>
              <a style="color: #fff;text-decoration: none" href="mailto:CS@orangeconnex.com?title=title1&body=body<br>new row">{{$t('global.Mail')}}</a>
            </span>
            </div>
          </div>
          <!--2-->
          <div class="col-md-12 copyright">
            <span>
              <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502005284">
                <img src="../assets/imgs/record.png" style="float:left;display: inline-block"/>
              </a>
              <div style="line-height: 20px;">
                <span><a style="color: #FFFFFF" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502005284" target="_blank">沪公网安备 31010502005284号 </a></span>
                <span style="display: inline-block">©2018{{ nowYear }}</span>
                <span>{{$t('global.CopyRight')}}<a style="color: #FFFFFF" href="https://beian.miit.gov.cn" target="_blank">闽ICP备18018224号-4</a></span>
              </div>
            </span>
          </div>
        </div>

        <div class="col-md-2 qrcode">
          <img src="../images/qrcode.jpg" alt="">
          <h5>{{$t('global.Wechat')}}</h5>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
    export default {
        name: "Footer",
        computed:{
          nowYear:function(){
            let myDate = new Date();
            return myDate.getFullYear() > 2018 ? '-'+myDate.getFullYear() : '';
          }
        }
    }
</script>
<style lang="less" scoped>
.padding0{
  padding: 0;
}
.width30{
  width: auto;
}
</style>




// WEBPACK FOOTER //
// Footer.vue?64ca71f9